import * as moment from "moment"
import { map, pipe } from "rxjs"
import { ProcessingStatus } from "src/app/core/enums/lead/processing-status.enum"
import { QualificationOutcome } from "src/app/core/enums/lead/qualification-outcome.enum"
import { QualificationStatus } from "src/app/core/enums/lead/qualification-status.enum"
import { UserOwnershipKind } from "src/app/core/enums/user/user-ownership-kind.enum"
import { LeadHead } from "src/app/core/models/lead/lead-head.model"
import { LeadHeadDto } from "src/app/infrastructure/lobby-proxy/DTOs/lead.dto"
import { changeTimeZone } from "../../utils/functions/change-timezone.func"



export const mapLeadHeadDtoToLeadHead = pipe(
    map((source: LeadHeadDto) => LeadHeadDtoToLeadHead(source))
)

export function LeadHeadDtoToLeadHead(source: LeadHeadDto): LeadHead {

    return {
        id: source.leadId,
        externalId: source.externalId,
        injectorExternalId: source.leadInjectorExternalId,

        processingStatus: ProcessingStatus[source.processingStatus as keyof typeof ProcessingStatus],
        qualificationStatus: QualificationStatus[source.qualificationStatus as keyof typeof QualificationStatus],
        qualificationOutcome: QualificationOutcome[source.qualificationOutcome as keyof typeof QualificationOutcome],

        lastStatusUpdated: new Date(source.lastStatusUpdated),
        created: new Date(source.created),
        updated: new Date(source.updated),

        ownerGrantorId: source.ownerGrantorId,
        ownerId: source.ownerId,
        ownershipKind: source.ownershipKind ?
            UserOwnershipKind[source.ownershipKind as keyof typeof UserOwnershipKind] :
            null,

        description: source.description,
        comment: source.comment,
        businessName: source.businessName,
        version: source.version
    }
}